import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6ffae15a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mt-2"
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-4 mt-3"
}, null, -1));
const _hoisted_5 = {
  key: 0,
  class: "i-layer"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = {
  class: "col-12 mb-3"
};
const _hoisted_8 = {
  class: "fw-medium fsi-14 d-flex justify-content-center align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_9 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_10 = {
  style: {
    "margin-top": "1rem"
  },
  class: "col-12"
};
const _hoisted_11 = {
  key: 1,
  class: "i-layer"
};
const _hoisted_12 = {
  class: "row"
};
const _hoisted_13 = {
  class: "col-12 mb-3"
};
const _hoisted_14 = {
  class: "fw-medium fsi-14 d-flex align-items-center justify-content-between mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_15 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_16 = {
  key: 0,
  style: {
    "width": "180px"
  }
};
const _hoisted_17 = {
  class: "d-none d-md-block mt-3",
  style: {
    "min-height": "100px"
  },
  "element-loading-text": "Loading..."
};
const _hoisted_18 = {
  class: "node-row-head"
};
const _hoisted_19 = {
  style: {
    "width": "25%"
  },
  class: "flex-center"
};
const _hoisted_20 = {
  style: {
    "width": "30%"
  },
  class: "flex-center"
};
const _hoisted_21 = {
  style: {
    "width": "30%"
  },
  class: "flex-center"
};
const _hoisted_22 = {
  style: {
    "width": "10%"
  },
  class: "flex-center"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  style: {
    "width": "25%"
  },
  class: "flex-center"
};
const _hoisted_25 = {
  style: {
    "width": "30%"
  },
  class: "flex-center"
};
const _hoisted_26 = {
  style: {
    "width": "30%"
  },
  class: "flex-center"
};
const _hoisted_27 = {
  style: {
    "width": "10%"
  },
  class: "flex-center"
};
const _hoisted_28 = {
  key: 0,
  class: "d-flex justify-content-center mt-3"
};
const _hoisted_29 = {
  key: 1,
  class: "flex-center mt-5"
};
const _hoisted_30 = {
  style: {
    "color": "#b8b8b8"
  },
  class: "fsi-14"
};
const _hoisted_31 = {
  class: "d-block d-md-none mt-2",
  style: {
    "min-height": "100px"
  },
  "element-loading-text": "Loading..."
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = {
  class: "d-flex"
};
const _hoisted_34 = {
  style: {
    "width": "85%"
  }
};
const _hoisted_35 = {
  class: "d-flex align-items-center justify-content-between mb-1"
};
const _hoisted_36 = {
  class: "d-flex align-items-center justify-content-between mb-1"
};
const _hoisted_37 = {
  class: "d-flex align-items-center justify-content-between mb-1"
};
const _hoisted_38 = {
  style: {
    "width": "15%"
  },
  class: "flex-center justify-content-end"
};
const _hoisted_39 = {
  key: 1,
  style: {
    "width": "100%",
    "height": "1px",
    "background-color": "rgb(232 232 232)"
  }
};
const _hoisted_40 = {
  key: 0,
  class: "d-flex justify-content-center mt-3"
};
const _hoisted_41 = {
  key: 1,
  class: "flex-center mt-5"
};
const _hoisted_42 = {
  style: {
    "color": "#b8b8b8"
  },
  class: "fsi-14"
};
const _hoisted_43 = {
  key: 0,
  style: {
    "margin-top": "2rem"
  }
};
const _hoisted_44 = {
  key: 0
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row mb-3 mt-3"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "col-12 mb-1"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-18"
}, "Migrate to the lending pool")])], -1));
const _hoisted_46 = {
  class: "row mt-3"
};
const _hoisted_47 = {
  class: "col-12"
};
const _hoisted_48 = {
  key: 0,
  class: "row mb-3 mt-2 i-layer"
};
const _hoisted_49 = {
  class: "col-12 mb-1"
};
const _hoisted_50 = {
  key: 1,
  class: "row mt-4"
};
const _hoisted_51 = {
  class: "col-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  const _component_SuccessFilled = _resolveComponent("SuccessFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_SingerV2 = _resolveComponent("SingerV2");
  const _component_AdCard2 = _resolveComponent("AdCard2");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.Node')) + " f0" + _toDisplayString($props.nodeId), 1)]), _hoisted_4, $data.isMigrator ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('subpool.The node has not joined the StakingPool or has already been upgraded')), 1)])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
    class: "btn btn-outline-clear w-100 i-button",
    onClick: $options.back
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.return')), 1)]),
    _: 1
  }, 8, ["onClick"])])])])) : _createCommentVNode("", true), !$data.isMigrator ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('subpool.select address')), 1), $options.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_el_input, {
    modelValue: $data.search.data,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.search.data = $event),
    onInput: $options.changeSearch,
    placeholder: _ctx.$t('subpool.Search Contract Pool'),
    "suffix-icon": $data.Search
  }, null, 8, ["modelValue", "onInput", "placeholder", "suffix-icon"])])) : _createCommentVNode("", true)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('subpool.Contract address')), 1), _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('farm.Position')), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('farm.Debt')), 1), _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('subpool.select')), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.poolList, (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [!$data.readySign || $data.checkIndex === index ? (_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["node-row", $data.checkIndex === index ? 'node-row-check' : '']),
      key: index,
      onClick: $event => $options.checkPool(index)
    }, [_createElementVNode("div", _hoisted_24, _toDisplayString($options.simpleValue(item.address, 6, 6)), 1), _createElementVNode("div", _hoisted_25, _toDisplayString($options.externalFormatFilPrice(item.total_position)), 1), _createElementVNode("div", _hoisted_26, _toDisplayString($options.externalFormatFilPrice(item.total_debt)), 1), _createElementVNode("div", _hoisted_27, [$data.checkIndex === index ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 0,
      size: "20",
      color: "#6752F0"
    }, {
      default: _withCtx(() => [_createVNode(_component_SuccessFilled)]),
      _: 1
    })) : _createCommentVNode("", true)])], 10, _hoisted_23)) : _createCommentVNode("", true)], 64);
  }), 256)), $data.search.total / $data.search.size > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_el_pagination, {
    layout: "prev, pager, next",
    onCurrentChange: $options.pageChange,
    total: $data.search.total,
    "page-size": $data.search.size,
    "current-page": $data.search.page
  }, null, 8, ["onCurrentChange", "total", "page-size", "current-page"])])) : _createCommentVNode("", true), $options.isConnected && !$data.loadingPool && $data.poolList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('subpool.not find node migrator')), 1)])) : _createCommentVNode("", true), !$options.isConnected ? (_openBlock(), _createElementBlock("button", {
    key: 2,
    class: "btn btn-primary w-100 border-radius-20 mt-3",
    type: "submit",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.connectWallet && $options.connectWallet(...args))
  }, _toDisplayString(_ctx.$t('common.Connect Wallet')) + " " + _toDisplayString($options.isConnecting ? ' (connecting...)' : ''), 1)) : _createCommentVNode("", true)])), [[_directive_loading, $data.loadingPool]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.poolList, (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: index
    }, [!$data.readySign || $data.checkIndex === index ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["node-row-md", $data.checkIndex === index ? 'node-row-check' : '']),
      onClick: $event => $options.checkPool(index)
    }, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('subpool.pooladdress')), 1), _createElementVNode("div", null, _toDisplayString($options.simpleValue(item.address, 6, 6)), 1)]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.Position')), 1), _createElementVNode("div", null, _toDisplayString($options.externalFormatFilPrice(item.total_position)), 1)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.Debt')), 1), _createElementVNode("div", null, _toDisplayString($options.externalFormatFilPrice(item.total_debt)), 1)])]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", null, [$data.checkIndex === index ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 0,
      size: "24",
      color: "#6752F0"
    }, {
      default: _withCtx(() => [_createVNode(_component_SuccessFilled)]),
      _: 1
    })) : _createCommentVNode("", true), $data.checkIndex !== index ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 1,
      size: "24",
      color: "#cccccc"
    }, {
      default: _withCtx(() => [_createVNode(_component_SuccessFilled)]),
      _: 1
    })) : _createCommentVNode("", true)])])])], 10, _hoisted_32)) : _createCommentVNode("", true), $data.checkIndex !== index && index !== $data.poolList.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_39)) : _createCommentVNode("", true)], 64);
  }), 128)), $data.search.total / $data.search.size > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createVNode(_component_el_pagination, {
    layout: "prev, pager, next",
    onCurrentChange: $options.pageChange,
    total: $data.search.total,
    "page-size": $data.search.size,
    "current-page": $data.search.page
  }, null, 8, ["onCurrentChange", "total", "page-size", "current-page"])])) : _createCommentVNode("", true), !$data.loadingPool && $data.poolList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('farm.Cannot find a node with the same owner')), 1)])) : _createCommentVNode("", true)])), [[_directive_loading, $data.loadingPool]]), !$data.readySign && $data.poolList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_43, [$data.poolHealthyErr ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    disabled: true,
    class: "btn btn-info w-100 i-button"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.The debt of the node has exceeded the maximum debt')), 1)]),
    _: 1
  })) : _createCommentVNode("", true), !$data.poolHealthyErr ? (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    disabled: $data.checkIndex < 0,
    class: "btn btn-primary w-100 i-button",
    onClick: $options.migrator,
    loading: $data.loading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Confirm')), 1)]),
    _: 1
  }, 8, ["disabled", "onClick", "loading"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), $data.readySign ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_hoisted_45, _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createVNode(_component_SingerV2, {
    ref: "singer",
    singerType: "approval",
    waitTime: 30000,
    btnProposal: "Send Proposal",
    "contract-method": $data.contractMethod,
    "contract-a-b-i": $data.contractABI,
    "is-call-evm": false,
    "from-address": $data.fromAddress,
    "to-f0-address": $data.toF0Address,
    contractParams: $data.contractParams,
    onNext: $options.complete
  }, null, 8, ["contract-method", "contract-a-b-i", "from-address", "to-f0-address", "contractParams", "onNext"])])]), $data.showCancel && !$data.completeFlag ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createVNode(_component_el_button, {
    class: "btn btn-outline-clear w-100 i-button",
    onClick: $options.reset
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('change.cancel')), 1)]),
    _: 1
  }, 8, ["onClick"])])])) : _createCommentVNode("", true), $data.completeFlag ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createVNode(_component_AdCard2, {
    title: _ctx.$t('subpool.You have successfully migrated to the lending pool'),
    "btn-text": _ctx.$t('Onboarding.View Node'),
    onBtnClick: $options.viewNode
  }, null, 8, ["title", "btn-text", "onBtnClick"])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
}